// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginActionCard_root__A4uiJ","root__main":"LoginActionCard_root__main__ETjjc","form":"LoginActionCard_form__OOiYA","root__footer":"LoginActionCard_root__footer__0lCnJ"};